export default {
    isLoading:false,
    NavMenuActive:'/',
    userInfo:{},
    // 登陆返回的企业信息
    corporationInfo:{},
    // 当前默认是404 无权限
    newUser:{},
    is404:true,
    headNavActive:'/',
    companyList:[],
    // 是否显示切换企业的弹框
    isCompanyModal:false,
    vueScrollOps:{
        bar:{
            background: '#E4E8ED',
        }
    },
    isFlag:true,
}